<template>
    <div>
        <div class="dx-field">
            <div class="dx-field-label">Дата перевода контрагента в архив</div>
            <div class="dx-field-value">
                <dx-date-box :value="data.archive_date" />
            </div>
        </div>
    </div>
</template>

<script setup>
import { inject } from 'vue';
import { DxDateBox } from 'devextreme-vue';

const data = inject('serverData');
</script>
